import React from 'react'
import graphql from 'graphql'
import Layout from './index'
import { addLocaleData } from 'react-intl'

import messages from '../data/messages/es'
import es from 'react-intl/locale-data/es'
import 'intl/locale-data/jsonp/es'

addLocaleData(es)

export default props => <Layout {...props} i18nMessages={messages} />

export const pageQuery = graphql`
  query LayoutES {
    site {
      siteMetadata {
        languages {
          defaultLangKey
          langs
        }
      }
    }
    headerLogo: imageSharp(id: { regex: "/main-logo/" }) {
      sizes(maxWidth: 211) {
        ...GatsbyImageSharpSizes
      }
    }
    footerLogo: imageSharp(id: { regex: "/footer-logo/" }) {
      sizes(maxWidth: 211) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/es.js